module.exports = __webpack_public_path__ + "static/Platinum-level-a13ceabfc642160b540635e2cfd71b84.png";